import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '../contexts/auth'

const UnProtectedRoute = ({ children }) => {
  const { user } = useAuth()
  const location = useLocation()

  if (user) {
    return <Navigate to='/home' replace state={{ from: location }} />
  }

  return children
}

export default UnProtectedRoute
